import { makeStyles, Theme } from '@material-ui/core/styles';
import { TypeText } from '@material-ui/core/styles/createPalette';
/**
 *
 * Material UI styles for Count
 *
 *
 * @see https://material-ui.com/styles/basics
 *
 */

const useStyles = makeStyles<Theme, { textColor: keyof TypeText }>(theme => ({
  number: {
    backgroundColor: theme.palette.common.gray200,
    borderRadius: 12,
    color: props => theme.palette.text[props.textColor || 'disabled'],
    fontWeight: 'bold',
    height: 24,
    lineHeight: '24px',
    minWidth: 24,
    padding: theme.spacing(0, 1),
    textAlign: 'center',
  },
}));

export default useStyles;
